export default __webpack_public_path__ + "static/comparisons-app-creation-277b5e9a72280bf7692781ac90ccb890.webp";